
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Please note that I am also available to commission for social media banners,
icons, custom OC designs, OC and character redesigns, YouTube thumbnails,
artworks to accompany audio drama readings, fanfiction/book covers, expression
sets for YouTube videos and comics.`}</p>
    <p>{`If you have specific artwork needs please do not feel shy, contact me and I can
give you a quote for any project!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;